module.exports = "/_next/static/images/illinois-44f43b8db9129782e3f518ec7516e8b2.svg";